module.exports = __webpack_public_path__ + "static/media/home-otc-img1.88659897.svg";